import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CreditCard, MailCheck, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function ClosingSection() {
  return <section className="bg-bbq-surface py-12 md:py-24 px-4 border-t border-white/5" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white uppercase tracking-wide mb-8 md:mb-12" data-id="element-3">
          Tienes dos caminos ahora mismo:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10 md:mb-16" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-bbq-dark p-8 rounded-xl border border-white/5 opacity-70" data-id="element-5">
            <h3 className="text-xl font-display font-bold text-gray-400 uppercase mb-4" data-id="element-6">
              Camino A
            </h3>
            <p className="text-gray-500" data-id="element-7">
              Llegar el 19 de Junio con un regalo genérico que papá va a
              agradecer por compromiso, guardar en un cajón y olvidar para
              siempre. Mientras la carne del domingo sigue quedando dura y la
              plata del supermercado se sigue botando a la basura.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-bbq-ember/20 to-bbq-dark p-8 rounded-xl border border-bbq-ember/50 relative" data-id="element-8">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-bbq-ember text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-9">
              Recomendado
            </div>
            <h3 className="text-xl font-display font-bold text-white uppercase mb-4" data-id="element-10">
              Camino B
            </h3>
            <p className="text-gray-200" data-id="element-11">
              Llegar el 19 de Junio con el regalo que papá realmente quería pero
              nunca pidió. Verlo leer el manual el sábado y aplicar las técnicas
              el domingo. Escuchar a la familia decir "oye viejo, esta es la
              mejor carne que has hecho en tu vida". Y saber que tú hiciste eso
              posible por menos de $15.000.
            </p>
          </motion.div>
        </div>

        <motion.button onClick={() => {
        trackAddToCart();
        window.location.href = 'https://www.merlanis.com/cart/53892945052016:1';
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full md:w-auto bg-bbq-ember hover:bg-bbq-ember-dark text-white font-display text-xl md:text-2xl uppercase tracking-wider py-6 px-8 md:px-16 rounded-md transition-all duration-300 shadow-[0_0_40px_rgba(232,98,45,0.3)] hover:shadow-[0_0_60px_rgba(232,98,45,0.5)] flex flex-col items-center justify-center gap-2 mx-auto" data-id="element-12">
          <span className="flex items-center gap-3" data-id="element-13">
            SÍ, QUIERO QUE PAPÁ SEA UN MAESTRO PARRILLERO
            <ArrowRight size={24} data-id="element-14" />
          </span>
        </motion.button>

        <ul className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-center gap-3 sm:gap-6 text-gray-300 text-sm" data-id="element-15">
          <li className="flex items-center gap-2" data-id="element-16">
            <CreditCard size={18} className="text-green-500 shrink-0" aria-hidden="true" data-id="element-17" />
            <span data-id="element-18">Pago 100% seguro con Webpay</span>
          </li>
          <li className="flex items-center gap-2" data-id="element-19">
            <MailCheck size={18} className="text-green-500 shrink-0" aria-hidden="true" data-id="element-20" />
            <span data-id="element-21">Entrega instantánea a tu email</span>
          </li>
          <li className="flex items-center gap-2" data-id="element-22">
            <ShieldCheck size={18} className="text-green-500 shrink-0" aria-hidden="true" data-id="element-23" />
            <span data-id="element-24">Garantía de 7 días sin preguntas</span>
          </li>
        </ul>
      </div>
    </section>;
}